(function() {
  'use strict';

  function validateEmailWithDomain(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email.trim());
  }

  function initNewsletterValidation() {
    const newsletterForms = document.querySelectorAll('.newsletter-form, .footer__newsletter');

    newsletterForms.forEach(form => {
      const emailInput = form.querySelector('input[type="email"]');
      
      if (!emailInput) return;

      form.addEventListener('submit', (e) => {
        const email = emailInput.value.trim();
        
        if (email && !validateEmailWithDomain(email)) {
          e.preventDefault();
          
          if (!email.includes('.')) {
            emailInput.setCustomValidity('Please include a domain extension (e.g., .com, .org)');
          } else if (email.endsWith('.')) {
            emailInput.setCustomValidity('Please complete the domain name');
          } else {
            emailInput.setCustomValidity('Please enter a valid email address');
          }
          
          emailInput.reportValidity();
          
          const resetValidity = () => {
            emailInput.setCustomValidity('');
            emailInput.removeEventListener('input', resetValidity);
          };
          emailInput.addEventListener('input', resetValidity);
        }
      });

      emailInput.addEventListener('input', () => {
        if (emailInput.validity.valid) {
          emailInput.setCustomValidity('');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterValidation);
  } else {
    initNewsletterValidation();
  }
})();